// extracted by mini-css-extract-plugin
export default {"container_active":"product_category_container_active__Ad1xy","container_inactive":"product_category_container_inactive__NYGG9","li_category":"product_category_li_category__fEflg"};